// Mirrors app-service utils/user/terms.py company_terms_accepted(): T&C accepted for the company.
// Deliberately not company.terms — that is the GPO fee tier, and 0% is a valid tier.
export function companyAcceptedTerms(
  company: { agreed_to_terms?: unknown; user_agreed?: unknown; agreed_to_terms_date?: unknown } | null | undefined,
): boolean {
  return !!(company?.agreed_to_terms && company?.user_agreed && company?.agreed_to_terms_date);
}
